import React from 'react';
import './Ribon.css';

const Ribon = () => {
  return (
    <div className="ribon-banner" role="status" aria-live="polite">
      <p className="ribon-text">
        POSTA FALAS NËSE POROSITË TUAJA JANË MBI VLERËN 30 EURO
      </p>
    </div>
  );
};

export default Ribon;
